<template>
  <div class="quick-find-main-container">
    <button v-html="mainButtonText" @click="mainButtonClicked"></button>

    <div v-if="showPopup" class="quick-find-popup-container">
      <div class="quick-find-popup">
        <div class="popup-title">{{popupTitle}}</div>
        <div class="popup-body">
          <div class="filters-container">
            <ButtonFilter :buttonText="buttonFilterButtonText" :filterWidth="buttonFilterPopupWidth" :isOpen.sync="buttonFilterIsOpen_">
              <slot name="extraFiltersTop"></slot> <!-- will appear above search filters, and above the refresh button -->
              <BoxContainer
                v-if="showSearchFilterBoxContainer"
                class="search-filters"
                title="Search"
              >
                <Dropdown
                  :items="searchByDropdownItems"
                  :itemKey="searchByDropdownItemKey"
                  :selectedObject.sync="searchByDropdownSelectedObject_"
                  placeholder="Search By"
                  :isRequired="true"
                  :errorMessage.sync="searchByDropdownErrorMessage"
                  :isDisabled="searchByDropdownIsDisabled"
                  @selected="searchByDropdownSelected"
                />
                <Dropdown
                  :items="searchCriteriaDropdownItems"
                  :itemKey="searchCriteriaDropdownItemKey"
                  :selectedObject.sync="searchCriteriaDropdownSelectedObject_"
                  placeholder="Search Criteria"
                  :isRequired="true"
                  :errorMessage.sync="searchCriteriaDropdownErrorMessage"
                  :isDisabled="searchCriteriaDropdownIsDisabled"
                  @selected="searchCriteriaDropdownSelected"
                />
                <Input
                  v-if="searchValueControlType === 'Input'"
                  :inputValue.sync="searchInputValue_"
                  :isRequired="true"
                  :errorMessage.sync="searchInputErrorMessage"
                  :isDisabled="searchValueControlIsDisabled"
                  placeholder="Search"
                />
                <DateTimePicker
                  v-else-if="searchValueControlType === 'DateTimePicker'"
                  :value.sync="searchDateTimePickerValue_"
                  :showTime="searchDateTimePickerShowTime"
                  :isRequired="true"
                  :errorMessage.sync="searchDateTimePickerErrorMessage"
                  :isDisabled="searchValueControlIsDisabled"
                  placeholder="Search"
                />
              </BoxContainer>
              <slot name="extraFiltersBottom"></slot> <!-- will appear below search filters, and above the refresh button -->
              <div class="refresh-button-container">
                <button @click="refreshButtonClicked">Refresh</button>
              </div>
            </ButtonFilter>
            <div class="filters-extra-space-container">
              <slot name="filtersExtraSpace"></slot> <!-- will appear on the right of the Change Filters button -->
            </div>
          </div>
          <div class="search-results-header-container">
            <slot name="searchResultsHeader"></slot> <!-- will appear below TableBox -->
          </div>
          <div class="search-results-container">
            <slot name="searchResultsLeftSidebar"></slot> <!-- will appear on the left of the TableBox -->
            <TableBox
              class="table-box-component"
              :title="resultsTableBoxTitle"
              :tableData="resultsTableBoxData"
              :dataType="resultsTableBoxDataType"
              :selectedRow.sync="resultsTableBoxSelectedRow"
              :maxSelection="resultsTableBoxMaxSelection"
              :rollSelection="resultsTableBoxRollSelection"
              :hideColumns="resultsTableBoxHideColumns"
              :groupBy="resultsTableBoxGroupBy"
              :loading="resultsTableBoxIsLoading"
              @rowSelected="resultsTableBoxRowSelected"
            />
            <slot name="searchResultsRightSidebar"></slot> <!-- will appear on the right of the TableBox -->
          </div>
          <div class="search-results-footer-container">
            <slot name="searchResultsFooter"></slot> <!-- will appear below TableBox -->
          </div>
          <div class="call-to-action-buttons">
            <button @click="selectButtonClicked">
              <img src="https://dsmlib.logistics.systems/Icons/Save.png">
              {{selectButtonText}}
            </button>
            <button @click="closeButtonClicked">
              <img src="https://dsmlib.logistics.systems/Icons/Cancel.png">
              {{closeButtonText}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  components: {
  },
  data: function() {
    return {
      buttonFilterIsOpen_: false,

      searchByDropdownSelectedObject_: {},
      searchByDropdownErrorMessage: "",

      searchCriteriaDropdownSelectedObject_: {},
      searchCriteriaDropdownErrorMessage: "",

      searchInputValue_: "",
      searchInputErrorMessage: "",

      searchDateTimePickerValue_: null,
      searchDateTimePickerErrorMessage: "",

      resultsTableBoxSelectedRow: [],
    };
  },
  props: {
    mainButtonText: { type: String, default: function() { return "Quick Find"; } }, // label of main button to open popup, parsed as html

    showPopup: { type: Boolean, default: false }, // show/hide the main popup, will be updated with emit, use .sync
    popupTitle: { type: String, default: function() { return "Find Item"; } }, // change what is displayed as the title

    buttonFilterButtonText: { type: String, default: function() { return "Change Filter"; } }, // change the label on the filters button
    buttonFilterPopupWidth: { type: Number, default: 330 }, // change width of filters popup
    buttonFilterIsOpen: { type: Boolean, default: false }, // open/close button filter, use .sync

    showSearchFilterBoxContainer: { type: Boolean, default: true }, // show/hide search filters box

    searchByDropdownItems: { type: Array, default: function() { return []; } },
    searchByDropdownItemKey: { type: String, default: function() { return ""; } },
    searchByDropdownSelectedObject: { type: Object, default: function() { return {}; }}, // use .sync
    searchByDropdownIsDisabled: { type: Boolean, default: false },

    searchCriteriaDropdownItems: { type: Array, default: function() { return []; } },
    searchCriteriaDropdownItemKey: { type: String, default: function() { return ""; } },
    searchCriteriaDropdownSelectedObject: { type: Object, default: function() { return {}; }}, // use .sync
    searchCriteriaDropdownIsDisabled: { type: Boolean, default: false },

    searchValueControlType: { type: String, default: function() { return "Input"; } }, // "Input" | "DateTimePicker" supported for now, may add more in the future
    searchInputValue: { type: String, default: function() { return ""; } }, // use .sync
    searchDateTimePickerShowTime: { type: Boolean, default: false }, // show or hide time selection when "DateTimePicker" is passed for control type
    searchDateTimePickerValue: { type: Date, default: function() { return null; } }, // use .sync
    searchValueControlIsDisabled: { type: Boolean, default: false }, // affects ALL search value controls, regardless of control type used

    resultsTableBoxTitle: { type: String, default: function() { return "Results"; } }, // change the title on the TableBox
    resultsTableBoxData: { type: Array, default: function() { return []; } }, // data to be displayed on the TableBox
    resultsTableBoxDataType: { type: Object, default: function() { return {}; } }, // data type to be used for the TableBox
    resultsTableBoxSelectedIndex: { type: Array, default: function() { return []; } }, // programatically select row by index, ONE WAY ONLY, WILL NOT BE UPDATED BACK
    resultsTableBoxMaxSelection: { type: Number, default: 1 }, // maximum number of rows allowed to be selected at the same time
    resultsTableBoxRollSelection: { type: Boolean, default: true }, // rollover selection once maximum number of selected rows has been reached
    resultsTableBoxHideColumns: { type: Array, default: function() { return []; } }, // array of columns to hide by name
    resultsTableBoxGroupBy: { type: String, default: function() { return ""; } }, // name of column to group by
    resultsTableBoxIsLoading: { type: Boolean, default: false }, // indicates if data for the TableBox is being loaded or not

    selectButtonText: { type: String, default: function() { return "Select"; } }, // change the label of the primary (affirmative) button 
    closeButtonText: { type: String, default: function() { return "Close"; } }, // change the label of the secondary button

    // available slots: (refer to template for positions)
    // - extraFiltersTop
    // - extraFiltersBottom
    // - filtersExtraSpace
    // - searchResultsHeader
    // - searchResultsLeftSidebar
    // - searchResultsRightSidebar
    // - searchResultsFooter

    // events:
    // @refresh (triggered when the refresh button in the Change Filters popup is clicked, regardless of whether there are errors or not)
    //   emits 2 parameters, param 1 - boolean indicating if there are errors or not, param 2 - object containing user's input
    // @resultsTableBoxRowSelect (triggered when a row in the TableBox is selected)
    //   emits 2 parameters, param 1 - row object, param 2 - boolean indicating whether it was selected or deselected
    // @select (triggered when the Select button at the bottom is clicked)
    //   emits the selected row in the results TableBox, empty array emitted if no rows are selected
  },
  methods: {
    mainButtonClicked: function(pointerEvent) {
      this.$emit("update:showPopup", true);
    },
    searchByDropdownSelected: function(selectedItem) { // data field changed
      this.$emit("update:searchByDropdownSelectedObject", selectedItem); // update prop, this will trigger the watcher property
    }, // but the watcher property won't retrigger this event watcher, so there shouldn't be an infinite loop
    searchCriteriaDropdownSelected: function(selectedItem) { // data field changed
      this.$emit("update:searchCriteriaDropdownSelectedObject", selectedItem); // update prop, this will trigger the watcher property
    }, // but the watcher property won't retrigger this event watcher, so there shouldn't be an infinite loop
    refreshButtonClicked: function(pointerEvent) {
      let errors = false;

      // check required fields and set error messages if needed
      if (this.showSearchFilterBoxContainer) {
        if (!this.searchByDropdownSelectedObject_ || Object.keys(this.searchByDropdownSelectedObject_).length == 0) {
          this.searchByDropdownErrorMessage = "Search By required";
          errors = true;
        }

        if (!this.searchCriteriaDropdownSelectedObject_ || Object.keys(this.searchCriteriaDropdownSelectedObject_).length == 0) {
          this.searchCriteriaDropdownErrorMessage = "Search Criteria required";
          errors = true;
        }

        switch (this.searchValueControlType) {
          case "Input":
            if (!this.searchInputValue_) {
              this.searchInputErrorMessage = "Search keyword required";
              errors = true;
            }
            break;

          case "DateTimePicker":
            if (!this.searchDateTimePickerValue_) {
              this.searchDateTimePickerErrorMessage = "Search date required";
              errors = true;
            }
            break;

          default:
            if (process.env['NODE_ENV'] == 'development') {
              console.error("[QuickFind] searchValueControlType is invalid");
            }
            break;
        }
      }

      let inputs = {};

      if (this.showSearchFilterBoxContainer) {
        inputs["searchBy"] = this.searchByDropdownSelectedObject_;
        inputs["searchCriteria"] = this.searchCriteriaDropdownSelectedObject_;

        switch (this.searchValueControlType) {
          case "Input":
            inputs["searchValue"] = this.searchInputValue_;
            break;

          case "DateTimePicker":
            inputs["searchValue"] = this.searchDateTimePickerValue_;
            break;

          default:
            if (process.env['NODE_ENV'] == 'development') {
              console.error("[QuickFind] searchValueControlType is invalid");
            }
            break;
        }
      }

      // emit even though there are errors, so that the parent component can check its own extra filters and set its own error messages if needed
      this.$emit("refresh", errors, inputs);
    },
    resultsTableBoxRowSelected: function(row, selected) {
      this.$emit("resultsTableBoxRowSelect", row, selected);
    },
    selectButtonClicked: function(pointerEvent) {
      this.$emit("select", this.resultsTableBoxSelectedRow);
    },
    closeButtonClicked: function(pointerEvent) {
      this.$emit("update:showPopup", false);
    },
  },
  mounted() {
  },
  watch: {
    buttonFilterIsOpen: function(newValue) { // prop changed
      this.buttonFilterIsOpen_ = newValue; // update data field
    },
    buttonFilterIsOpen_: function(newValue) { // data field changed
      this.$emit("update:buttonFilterIsOpen", newValue); // update prop
    },
    searchDateTimePickerValue: function(newDate) { // prop changed
      if (
        this.searchDateTimePickerValue_ && // data field is not null
        newDate && // new prop is not null
        this.searchDateTimePickerValue_.getDifference(newDate)["days"] == 0 // data and prop are the same date
      ) {
        return; // don't update data, this is to prevent an infinite loop
      }

      this.searchDateTimePickerValue_ = newDate;
    },
    searchDateTimePickerValue_: function(newDate) { // data field changed
      if (
        this.searchDateTimePickerValue && // prop is not null
        newDate && // new data field is not null
        this.searchDateTimePickerValue.getDifference(newDate)["days"] == 0 // data and prop are the same date
      ) {
        return; // don't update prop, this is to prevent an infinite loop
      }

      this.$emit("update:searchDateTimePickerValue", newDate);
    },
    searchByDropdownSelectedObject: { // prop changed
      handler: function(newSearchBy) { // update data field, this won't trigger the select event
        this.searchByDropdownSelectedObject_ = newSearchBy; // so there shouldn't be an infinite loop
      },
      deep: true,
    },
    // searchByDropdownSelectedObject_: { // data field changed, this watcher property doesn't update the prop
    //   handler: function(newSearchBy) { // updating of the prop is handled by the @select event watcher
    //     if (newSearchBy[this.searchByDropdownItemKey].toLowerCase().includes("date")) { // if selected object has the word "date" in it
    //       const equalsToObject = ( // force search criteria to be "EQUALS TO"
    //         this.searchCriteriaDropdownItems.find((item) => {
    //           return item[this.searchCriteriaDropdownItemKey].toLowerCase() === "equals to"
    //         }) || {}
    //       );
    //       this.$emit("update:searchCriteriaDropdownSelectedObject", equalsToObject); // change prop to "equals to" object
    //       this.searchCriteriaDropdownSelectedObject_ = equalsToObject; // change data field in case the page implementing this component doesn't have a data field synced to the searchCriteria prop
    //       this.searchCriteriaDropdownIsDisabled = true; // disable criteria dropdown
    //       this.searchValueControlType = "DateTimePicker"; // allow entry of dates only
    //     } else {
    //       this.searchCriteriaDropdownIsDisabled = false; // enable criteria dropdown
    //       this.searchValueControlType = "Input"; // allow free entry of text
    //     }
    //   },
    //   deep: true,
    // },
    searchCriteriaDropdownSelectedObject: { // prop changed
      handler: function(newSearchCriteria) { // update data field, this won't trigger the select event
        this.searchCriteriaDropdownSelectedObject_ = newSearchCriteria; // so there shouldn't be an infinite loop
      },
      deep: true,
    },
    searchInputValue: function(newSearch) { // prop changed
      if (this.searchInputValue_ === newSearch) { // if data and prop are the same
        return; // don't update data field, this is to prevent an infinite loop
      }
      this.searchInputValue_ = newSearch;
    },
    searchInputValue_: function(newSearch) { // data field changed
      if (this.searchInputValue === newSearch) { // if data and prop are the same
        return; // don't update prop, this is to prevent an infinite loop
      }
      this.$emit("update:searchInputValue", newSearch)
    },
    resultsTableBoxSelectedIndex: function(newIndex) { // get row objects from TableBoxData and assign to resultsTableBoxSelectedRow
      const selectedRows = []; // the reason it has to be a watcher property is because if you just pass the indexes to TableBox,
      for (const index of newIndex) { // resultsTableBoxSelectedRow won't be updated by the TableBox
        if (this.resultsTableBoxData[index]) {
          selectedRows.push(this.resultsTableBoxData[index]);
        }
      }
      this.resultsTableBoxSelectedRow = selectedRows;
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.quick-find-main-container {

  > .quick-find-popup-container {
    position: fixed;
    top: $top-nav-height;
    left: 0;
    z-index: 999;
    height: calc(100% - #{$top-nav-height});
    width: 100%;
    padding: 0 42px;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    > .quick-find-popup {
      height: 95%;
      width: 100%;
      border-radius: 5px;
      background-color: white;

      > .popup-title {
        border-bottom: 2px solid rgb(180,180,180);
        padding: 5px;
        font-size: 12px;
        font-weight: bolder;
      }

      > .popup-body {
        height: calc(100% - 30px); // deduct height of popup-title
        padding: 5px;
        display: flex;
        flex-direction: column;

        > .filters-container {
          margin-bottom: 5px;
          display: flex;
          flex-direction: row;

          .search-filters {
            margin-top: 12px;
            display: flex;
            flex-direction: column;
          }

          .refresh-button-container {
            margin-top: 5px;
            display: flex;
            justify-content: flex-end;
          }

          > .filters-extra-space-container {
            flex: 1;
            display: flex;
            align-content: center;
          }
        }

        > .search-results-container {
          flex: 1;
          display: flex;
          flex-direction: row;
          overflow: scroll;

          > .table-box-component {
            flex: 1;
            font-size: 12px;
          }
        }

        > .call-to-action-buttons {
          margin-top: 5px;
          display: flex;
          flex-direction: row;
          justify-content: flex-end;

          > button {
            margin: 0 3px;

            > img {
              height: 25px;
              width: 25px;
            }
          }
        }
      }
    }
  }
}

</style>